var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyClipboard = function SvgCopyClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.923 1.846H6.769c-.679 0-1.231.552-1.231 1.231v2.462H3.076c-.678 0-1.23.551-1.23 1.23v6.154c0 .679.552 1.23 1.23 1.23H9.23c.68 0 1.231-.551 1.231-1.23v-2.461h2.462c.678 0 1.23-.552 1.23-1.231V3.077c0-.679-.552-1.23-1.23-1.23ZM3.076 12.923V6.77H9.23l.002 6.154H3.076Zm9.847-3.692H10.46V6.769c0-.679-.552-1.23-1.23-1.23H6.768V3.076h6.154v6.154Z",
    fill: "#30384C"
  })));
};
export default SvgCopyClipboard;